import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class DemoRegistrationService {

  constructor(private http: HttpClient, private occService: OccEndpointsService) { }

  getFormDataInitial() {
    return this.http.get(this.occService.buildUrl(`mydemo/demoformpagefields`));
  }

  submitDemoDataData(data: any) {
    return this.http.post(this.occService.buildUrl(`mydemo/registerDemoUser`), data);
  }


  displayTrainingData(data: any) {
    return this.http.post(this.occService.buildUrl(`mydemo/demos`), data);
  }
  sendConfirmationMail(emailAddress: string, demoCode: string) {
    return this.http.post(this.occService.buildUrl(`mydemo/democonfirmationemail?emailAddress=${emailAddress}&demoCode=${demoCode}`), null);
  }
  getCustomerData(emailAddress: string) {
    return this.http.get(this.occService.buildUrl(`mydemo/getexistingcustomer?emailAddress=${emailAddress}`));
  }
}
